import { ReactNode, useEffect } from "react";

import { ReactComponent as ErrorIcon } from "../../../assets/bannerDanger.svg";
import { ReactComponent as SuccessIcon } from "../../../assets/green-tick.svg";
import { ReactComponent as WarningIcon } from "../../../assets/bannerWarning.svg";
import { ReactComponent as InfoIcon } from "../../../assets/emphisised-tooltip-info.svg";

import { Visible } from "util/enhancer";
import { VisibleSection } from "../VisibleSection";

export enum Status {
  ERROR = "error",
  INFO = "info",
  WARNING = "warning",
  SUCCESS = "success",
}

export type NotificationProps = {
  status: Status;
  title?: string;
  children: string | ReactNode;
  timeout?: number;
  onExpire?: () => void;
  className?: string;
};

export function Notification(props: NotificationProps) {
  const { title, status, timeout = 5000, onExpire, className = "" } = props;

  useEffect(() => {
    setTimeout(() => {
      onExpire?.();
    }, timeout);
    // eslint-disable-next-line
  }, [onExpire]);

  return (
    <div
      role="alert"
      aria-live="polite"
      aria-label={title || status}
      className={`notification notification--${status} ${className}`}
    >
      {notificationIcon(status)}
      <div>
        <VisibleSection visible={!!title}>
          <div className="notification-title">{title}</div>
        </VisibleSection>
        <div className="notification-content">{props.children}</div>
      </div>
    </div>
  );
}

function notificationIcon(status: Status) {
  switch (status) {
    case Status.ERROR:
      return <ErrorIcon />;
    case Status.SUCCESS:
      return <SuccessIcon />;
    case Status.WARNING:
      return <WarningIcon />;
    case Status.INFO:
      return <InfoIcon />;
  }
}

export const VisibleNotification = Visible(Notification);
